"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var SearchField = function SearchField(_ref) {
  var placeholder = _ref.placeholder,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      onChange = _ref.onChange,
      _ref$onSearchIconClic = _ref.onSearchIconClick,
      onSearchIconClick = _ref$onSearchIconClic === void 0 ? function () {} : _ref$onSearchIconClic,
      dataTestId = _ref.dataTestId,
      _ref$closeIconColor = _ref.closeIconColor,
      closeIconColor = _ref$closeIconColor === void 0 ? 'primary' : _ref$closeIconColor,
      _ref$iconColor = _ref.iconColor,
      iconColor = _ref$iconColor === void 0 ? 'grey' : _ref$iconColor,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["placeholder", "value", "disabled", "onChange", "onSearchIconClick", "dataTestId", "closeIconColor", "iconColor"]);
  var clearVisible = !!value;
  var handleClear = (0, _react.useCallback)(function () {
    onChange({
      target: {
        value: ''
      }
    });
  }, [onChange]);
  return /*#__PURE__*/_react["default"].createElement(_material.TextField, (0, _extends2["default"])({
    fullWidth: true,
    disabled: disabled,
    variant: "outlined",
    value: value,
    onChange: onChange,
    placeholder: placeholder,
    InputProps: _objectSpread({
      inputProps: {
        'data-testid': dataTestId || placeholder.toLowerCase().split(' ').join('-')
      },
      startAdornment: /*#__PURE__*/_react["default"].createElement(_material.InputAdornment, {
        position: "start"
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        icon: "search",
        color: iconColor,
        onClick: onSearchIconClick
      }))
    }, clearVisible ? {
      endAdornment: /*#__PURE__*/_react["default"].createElement(_material.InputAdornment, {
        position: "end"
      }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
        color: closeIconColor
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        icon: "times",
        className: "Text-Pointer",
        onClick: handleClear
      })))
    } : {})
  }, otherProps));
};

var _default = /*#__PURE__*/(0, _react.memo)(SearchField);

exports["default"] = _default;